<template>
  <div class="">
    <Navbar />

    <div id="main">
      <div class="container">
        <div class="row">
          <div class="col-12 wrapper">
            <agile ref="agile" :autoplay="true" :autoplaySpeed="8000" :pauseOnHover="true" :fade="true" :dots="false"
              :navButtons="false" :arrows="false" @before-change="changeSlide($event)" style="background:#dadada;">
              <div class="slide" v-for="(val, key) in slide" :key="key">
                <img :src="val" />
              </div>
            </agile>
            <div class="cssarrow">
              <span @click="$refs.agile.goToPrev()">
                <i class="fas fa-caret-left"></i>
              </span>
              <span class="float-right" @click="$refs.agile.goToNext()">
                <i class="fas fa-caret-right"></i>
              </span>

            </div>
          </div>
        </div>
      </div>

      <div class="container">
        <div id="detail">
          <div class="text-center mb-4">
            <h4>IDIOM represents a remarkable roster of both emerging and accomplished voice talent from around the world
            </h4>
          </div>
          <div id="content" class="text-center">
            <small>Commercials, promos, animation, narration, video games, and more – IDIOM boasts over 30 years of
              experience in voice talent representation. We excel at building meaningful, profitable relationships between
              emerging and established voice talent and a wide range of clients, including domestic and international
              advertising agencies, television networks, independent producers, and other entertainment and new media
              clients. Our offices in Los Angeles, California; Honolulu, Hawaii; Bangkok, Thailand; and Mumbai, India,
              enable us to secure lucrative work for voice talent across North America, Australia/Oceania, and
              Asia.</small>
            <!-- <div class="mt-4">
              <small>“A true artist is not one who is inspired, but one who inspires others.” <br> -Salvador Dali</small>
            </div> -->
          </div>
        </div>
      </div>

      <div class="container">
        <div id="video" class="bg-white">
          <div class="mb-4">
            <h4>Feature Work</h4>
          </div>
          <carousel :autoplay="false" :autoplayHoverPause="true" :nav="false"
            :responsive="{ 0: { items: 1 }, 600: { items: 2 }, 1200: { items: 3 } }">
            <div class="video-column px-2" v-for="(val, key) in video" :key="key">
              <LazyVideo :poster="val.poster" :src="val.vdo" width="100%" style="height:230px" />
            </div>
          </carousel>
          <carousel :autoplay="false" :autoplayHoverPause="true" :nav="false"
            :responsive="{ 0: { items: 1 }, 600: { items: 2 }, 1200: { items: 3 } }">
            <div class="video-column px-2" v-for="(val, key) in video2" :key="key">
              <LazyVideo :poster="val.poster" :src="val.vdo" width="100%" style="height:230px" />
            </div>
          </carousel>
        </div>
      </div>

      <Footer />
    </div>

  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'

import { VueAgile } from 'vue-agile'
import carousel from 'vue-owl-carousel'

export default {
  name: 'Index',
  components: { Navbar, Footer, agile: VueAgile, carousel },
  data() {
    return {
      currentSlide: 0,
      slide: [
        "/slide/idiom-talent-audition.webp",
        "/slide/idiom-talent-engineers.webp",
        "/slide/idiom-talent-office.webp",
        "/slide/idiom-talent-lobby.jpg",
        "/slide/idiom-voiceover-talent.webp",

      ],
      video: [
        {
          poster: "video/0105N-IFKJJ-DKWPJ-LCCAQ.png",
          vdo: "video/TAKF4-F5Z4D-35F4A-2NQN6.mp4",
        },
        {
          poster: "video/5cdd4db2c138f_X76xdV6qKL.46.20 PM.png",
          vdo: "video/5cdd4db2c138f_X76xdV6qKL.mp4",
        },
        {
          poster: "video/5cdd986c559b4_p2H7vPbrER.03.39 AM.png",
          vdo: "video/5cdd986c559b4_p2H7vPbrER.mp4",
        },
        {
          poster: "video/H388W-7JBD1-J2ZNV-R8FX1.png",
          vdo: "video/Y5JPH-OSYZ3-EG6NP-2U9E8.mp4",
        },
        {
          poster: "video/5cdd5ac4842d4_ZzMwfsKCGK.05.59 PM.png",
          vdo: "video/5cdd5ac4842d4_ZzMwfsKCGK.mp4",
        },
        {
          poster: "video/UMVZZ-LSP7V-IDFO2-8D2JE.png",
          vdo: "video/EZSWZ-WXH59-G0WB0-VWSK4.mp4",
        },
        {
          poster: "video/5cdd4fe541d40_K5M2qyCNgj.55.36 PM.png",
          vdo: "video/5cdd4fe541d40_K5M2qyCNgj.mp4",
        },
        {
          poster: "video/5cdd4f5398653_xstmzIvBNf.53.17 PM.png",
          vdo: "video/5cdd4f5398653_xstmzIvBNf.mp4",
        },
        {
          poster: "video/ID5KD-3SSQV-YE00Y-7RE0R.png",
          vdo: "video/CE0H4-LJQ28-ALMF5-ZIYS9.mp4",
        }
      ],
      video2: [
        {
          poster: "video/T0KQI-XA8LF-UOG38-GAF0H.png",
          vdo: "video/CM2XH-WK9SF-DMGYD-YVN7G.mp4",
        },
        {
          poster: "video/D5KPI-G5BHL-9W4CQ-SPM3T.png",
          vdo: "video/5K6PS-PZB0C-FEH03-0H9CY.mp4",
        },
        {
          poster: "video/5cdd74fe8907d_d4gcsrgsDC.33.56 PM.png",
          vdo: "video/5cdd74fe8907d_d4gcsrgsDC.mp4",
        },
        {
          poster: "video/EJ2TN-DWA3J-HCJ8J-AIBC4.png",
          vdo: "video/90Q6Q-AR2M1-SGCDV-GS1FX.mp4",
        },
        {
          poster: "video/XA9L6-1TLYV-K3E9L-32K25.png",
          vdo: "video/ZIBM8-EHHSP-RQ01B-625S0.mp4",
        },
        {
          poster: "video/2DQ1D-N8YLW-K8P29-BX2M5.png",
          vdo: "video/24HQ7-L565G-SZGIM-XAAAB.mp4",
        },
        {
          poster: "video/7ZCA3-P5IIB-AZ2QO-6DU3Q.png",
          vdo: "video/TZQNH-RNC06-WL0GU-MEX47.mp4",
        },
        {
          poster: "video/U26RF-MBTBB-383B5-S2T5X.png",
          vdo: "video/GMEC6-SYP67-D0AJS-Q64JI.mp4",
        },
        {
          poster: "video/8VNI8-2ZTB2-0CBIW-JZFT6.png",
          vdo: "video/FIK9X-OYH5F-QDADW-JGWCR.mp4",
        }
      ],
    }
  },
  methods: {
    changeSlide($event) {
      let { currentSlide, nextSlide } = $event;
      if ((currentSlide == this.slide.length - 1) && (nextSlide == 0)) {
        this.slide = this.randomSlide(this.slide);
      }
    },
    randomSlide(arr) {
      if (arr.length <= 1) {
        return arr;
      }
      const indexToMove = this.getRandomInt(1, arr.length - 1);
      const [elementToMove] = arr.splice(indexToMove, 1);
      const newPosition = this.getRandomInt(1, arr.length);
      arr.splice(newPosition, 0, elementToMove);
      return arr;
    },
    getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }
  }
}
</script>

<style scoped>
/* #main { background-color:#aa4d8e !important; } */
#main {
  background-color: #894073 !important;
}

#detail {
  min-height: 1px;
  background: linear-gradient(#1b1b1b, #4e4e4e);
  color: #fff;
  /* padding: 50px; */
  padding: 30px 55px;
}

#detail h4 {
  font-size: 26px;
}

#detail #content {
  line-height: 1.8em;
  text-align: justify;
}

#detail #content small {
  font-size: 16px;
}

#video {
  padding: 50px;
}

@media (max-width: 600px) {
  #detail h4 {
    font-size: 18px;
    padding-bottom: 10px;
  }

  #detail #content {
    text-align: center;
  }

  #detail #content small {
    font-size: 14px;
  }

  #detail {
    padding: 25px;
  }

  #video {
    padding: 25px;
  }

  #video .video-column {
    padding: 0 !important;
  }
}

.slide {
  min-height: 50px;
}

.slide img {
  width: 100% !important;
  height: 100% !important;
  vertical-align: middle;
  transition: .3s all linear;
  -webkit-transition: .3s all linear;
}

.slide:hover img {
  transform: matrix(1.1, 0, 0, 1.1, 0, 0);
  -ms-transform: matrix(1.1, 0, 0, 1.1, 0, 0);
  -webkit-transform: matrix(1.1, 0, 0, 1.1, 0, 0);
}

.wrapper {
  position: relative;
  /* Establish a containing block for the absolute element */
  display: inline-block;
  /* To make width fit to the content */
}

.wrapper img {
  vertical-align: middle;
  /* Fix the gap under the inline level element */
}

.cssarrow {
  width: 100%;
  height: 0;
  border-style: solid;
  border-width: 0 20px 20px 0;
  border-color: transparent transparent transparent;

  position: absolute;
  top: 50%;
  left: 1%;
}

.cssarrow>span {
  color: white;
  font-size: 28px;
  padding: 0 15px;
  cursor: pointer;
}

video {
  background: #000;
}
</style>
